import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/driver-smartfuel",
		component: lazy(() => import("./DriverSmartfuelPage")),
	},
]);
